const SHOPIFY_RULE = {
  USD: {
    min: 0,
    max: 1e9
  },
  IDR: {
    min: 0,
    max: 1e9
  },
  MYR: {
    min: 0,
    max: 1e6
  },
  PHP: {
    min: 0,
    max: 1e6
  },
  THB: {
    min: 0,
    max: 5e5
  },
  CNY: {
    min: 0,
    max: 1e9
  },
  VND: {
    min: 0,
    max: 1e9
  },
  ISK: {
    min: 0,
    max: 1e9
  }
};
const SHOPEE_RULE = {
  USD: {
    min: 1,
    max: 1e9
  },
  SGD: {
    min: 0.01,
    max: 99999999
  },
  IDR: {
    min: 99,
    max: 15e7
  },
  MYR: {
    min: 0.1,
    max: 1e9
  },
  PHP: {
    min: 5,
    max: 1e5
  },
  THB: {
    min: 1,
    max: 5e5
  },
  CNY: {
    min: 0,
    max: 1e9
  },
  VND: {
    min: 1e3,
    max: 12e7
  }
};
const LAZADA_RULE = {
  IDR: {
    min: 1,
    max: 999999999
  },
  SGD: {
    min: 0.5,
    max: 5500
  },
  MYR: {
    min: 0.2,
    max: 1e5
  },
  PHP: {
    min: 1,
    max: 999999
  },
  THB: {
    min: 6,
    max: 999999
  },
  CNY: {
    min: 0,
    max: 1e9
  },
  VND: {
    min: 1e3,
    max: 99999999
  }
};
const AKULAKU_RULE = {
  IDR: {
    min: 1,
    max: 1e8
  },
  MYR: {
    min: 0.01,
    max: 35e3
  },
  PHP: {
    min: 1,
    max: 1e5
  },
  VND: {
    min: 1,
    max: 1e8
  }
};
export {SHOPIFY_RULE, SHOPEE_RULE, LAZADA_RULE, AKULAKU_RULE};
